import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formStyleConstants } from '../utils/constants/form-style-constants';

class FormConsentDetails extends Component {
    constructor(props) {
        super(props);
        this.state = { isOpened: false };
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.setState((state) => {
            return { isOpened: !state.isOpened };
        });
    }

    render() {
        const { consentDetails } = this.props;
        const { isOpened } = this.state;

        return (
            <div className='accordion-flexible accordion-flexible--button-right mt-md mb-sm'>
                <div
                    className={`accordion-flexible__wrapper ${isOpened ? formStyleConstants.isOpened : ''}`}
                    data-dc-component='accordion'
                >
                    <div className='accordion-flexible__button'>
                        <button
                            className='button-tertiary'
                            data-dc-accordion-ref='trigger[]'
                            onClick={this.handleClick}
                            aria-expanded={isOpened ? 'true' : 'false'}
                        >
                            <span className='button-content button-content--icon'>
                                <span> {consentDetails.label}</span>
                                <svg
                                    className='icon accordion-flexible__arrow-down'
                                    width='20'
                                    height='20'
                                    focusable='false'
                                >
                                    <use xlinkHref='#icon-arrow-down-circle'></use>
                                </svg>
                            </span>
                        </button>
                    </div>
                    <p
                        className={`accordion-flexible__copy copy ${isOpened ? 'accordion-text-visible' : 'accordion-text-hidden'}`}
                        data-dc-accordion-ref='content'
                    >
                        {consentDetails.text}
                    </p>
                </div>
            </div>
        );
    }
}

FormConsentDetails.propTypes = {
    consentDetails: PropTypes.object.isRequired
};

export default FormConsentDetails;
